<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    @import "../assets/css/common.css";
    body {
        background: green;
    }
    main {
        width: 100%;
        text-align: center;
    }

    .wrap {
        max-width: 750px;
        margin: 0 auto;
    }

    .activity-bg {
        width: 100%;
        display: inline-block;
        max-width: 750px;
        background-size: cover;
        background-position: center center;
        background-repeat: no-repeat;
    }

    .activity-bg img {
        width: 100%;
        max-width: 750px;
        max-height: 100%;
    }

    .content-topbox {
        width: 90%;
        background: none;
        padding-top: 10px;
        margin: 0 auto;
        height: 27vw;
        overflow: hidden;
    }

    .content-shareimg {
        width: 20%;
        position: absolute;
        right: 0px;
        top: 0px;
    }

    .content-logimg {
        width: 60%;
        margin-bottom: 2%;
        margin-top: 4%;
    }

    .content-titleimg {
        width: 80%;
    }

    .content-bottbox {
        max-width: 750px;
        background: none;
        overflow: hidden;
    }

    .content-bottbox > img {
        width: 100%;
    }

    .content-box form {
        padding: 0 20px;
    }

    .content-box fieldset {
        border: none;
        padding: 0;
    }

    .content-box label {
        display: block;
        line-height: 30px;
        font-size: 14px;
        color: #60D8C4;
        padding: 15px 0 10px;
    }

    .content-box input {
        width: 100%;
        height: 44px;
        line-height: 44px;
        font-size: 14px;
        border: none;
        background: #EAF8F6;
        border-radius: 5px;
        text-indent: 1em;
    }

    .content-val {
        width: 100%;
        height: 55%;
    }

    .content-price {
        height: 90px;
        padding: 10px;
        color: rgb(247, 221, 40);
        /*margin-bottom: 4%;*/
    }

    .content-price h1 {
        font-size: 36px;
        font-weight: 900;
        height: 50px;
        line-height: 50px;
    }

    .content-price > h1 > span {
        font-size: 16px;
    }

    .content-price p {
        font-size: 16px;
    }

    .content-button {
        margin: 0 8%;
        color: #fff;
        font-size: 18px;
        font-weight: 900;
    }

    .content-introduce {
        font-size: 12px;
        color: rgb(255, 255, 255);
    }

    .toast-body {
        display: block;
        top: 18%;
        padding-bottom: 20px;
        width: 80%;
        left: 10%;
    }

    .toast-title {
        color: rgb(102, 102, 102);
        border-bottom: 1px solid rgb(221, 221, 221);
        margin: 0px auto;
        display: inline-block;
        padding: 6px 0px;
        height: 50px;
        line-height: 50px;
        font-size: 18px;
    }

    .toast-msg {
        text-align: left;
        max-height: 290px;
        padding-bottom: 0;
    }

    .img-wrap {
        margin: 0 10%;
        height: 56vw;
        overflow: hidden;
    }

    .input-wrap {
        position: relative;
    }

    .input-wrap input {
        padding-left: 10px;
        border: none;
        background: #FFFFFF;
        border-radius: 30px;
        height: 48px;
        width: 80%;
        outline: none;
        font-size: 18px;
        text-align: left;
    }

    .login-get-code {
        position: absolute;
        right: 50px;
        top: 10px;
        border: none;
        padding: 0 5px;
        font-size: 18px;
        line-height: 30px;
        color: #7C7358;
        height: 30px;
        text-align: center;
        border-left: 1px solid #979797;
    }

    .msgs1 {
        color: rgb(114, 116, 118) !important;
    }

    @media screen and (min-width: 640px) {
        .content-logimg {
            width: 60%;
            margin-top: 0;
        }

        .content-button[data-v-02750f7b] {
            margin: 0 15%;
            color: #fff;
            font-size: 18px;
            font-weight: 900;
        }

        .input-wrap input[data-v-02750f7b] {
            width: 67%;
            height: 70px;
        }

        .login-get-code {
            position: absolute;
            right: 140px;
            top: 20px;
        }
    }
    @media (min-aspect-ratio: 3/4) {
        body, html {
            height: auto;
            overflow: scroll;
        }
        main[data-v-02750f7b] {
            height: 150vw;
        }
        .wrap, .activity-bg{
            height: 100%;
        }
        .input-wrap {
            margin-bottom: 10px;
        }
    }
    @media (max-aspect-ratio: 3/4) {
        body, html, .container,  .container main, .wrap, .activity-bg{
            height: 100%;
            overflow: hidden;
        }
        .img-wrap {
            margin: 0 11%;
        }
        .content-topbox {
            width: 80%;
        }
        .input-wrap {
            margin-bottom: 5px;
        }
    }
    @media (max-aspect-ratio: 9/14) {
        .content-topbox {
            width: 80%;
        }
        .img-wrap {
            margin: 0 10%;
        }
        .input-wrap {
            margin-bottom: 10px;
        }
        .content-button {
            margin-top: 15px;
        }
        .content-val {
            margin-top: 50px;
        }
    }
    @media (max-aspect-ratio: 9/16) {
        .content-topbox {
            width: 80%;
        }
        .input-wrap {
            margin-bottom: 10px;
        }
        .content-button {
            margin-top: 20px;
        }
        .content-val {
            margin-top: 125px;
        }
    }
    @media (max-aspect-ratio: 9/18) {
        .content-topbox {
            width: 80%;
        }
        .input-wrap {
            margin-bottom: 15px;
        }
        .content-button {
            margin-top: 20px;
        }
        .content-val {
            margin-top: 190px;
        }
    }
    @media (max-aspect-ratio: 9/19) {
        .content-topbox {
            width: 80%;
        }
        .input-wrap {
            margin-bottom: 15px;
        }
        .content-button {
            margin-top: 20px;
        }
        .content-val {
            margin-top: 240px;
        }
    }
</style>
<style lang="stylus" scoped>

.treatment-list {
    height: 100%;
    body {
    background: green;
}
main {
    position: absolute;
    height: 100%;
    width: 100%;
    text-align: center;
    overflow: hidden;
}

.wrap {
    height: 100%;
    max-width: 750px;
    margin: 0 auto;
    position: relative;
}

.activity-bg {
    display: inline-block;
    max-width: 100%;
    height: 100%;
    position: relative;
}

.activity-bg img {
    width: 100%;
    max-width: 750px;
    max-height: 120%;
}

.content-topbox {
    position: absolute;
    width: 90%;
    top: 0;
    height: 200px;
    background: none;
    left: 5%;
}

.content-logimg {
    width: 60%;
}

.content-shareimg {
    width: 20%;
    position: absolute;
    right: 0px;
    top: 0px;
}

.content-bottbox {
    position: absolute;
    width: 100%;
    height: 66%;
    background: none;
    bottom: 0;
    left: 0;
    z-index: 1;
    /*background: url(../assets/img/envelope/rdnew@3x.png) no-repeat;*/
    background-size: 100% 100%;
    transform: rotate(0deg);
    -ms-transform: rotate(0deg);
    /* IE 9 */
    -moz-transform: rotate(0deg);
    /* Firefox */
    -webkit-transform: rotate(0deg);
    /* Safari 和 Chrome */
    -o-transform: rotate(0deg);
    /* Opera */
}

.content-bottbox>img {
    width: 100%;
}

.content-box form {
    padding: 0 20px;
}

.content-box fieldset {
    border: none;
    padding: 0;
}

.content-box label {
    display: block;
    line-height: 30px;
    font-size: 14px;
    color: #60D8C4;
    padding: 15px 0 10px;
}

.content-box input {
    width: 100%;
    height: 44px;
    line-height: 44px;
    font-size: 14px;
    border: none;
    background: #EAF8F6;
    border-radius: 5px;
    text-indent: 1em;
}

.content-price h1 {
    font-size: 36px;
    font-weight: 900;
}

.content-price>h1>span {
    font-size: 16px;
}

.content-price p {
    font-size: 16px;
}

.content-button {
    width: 80%;
    height: 70px;
    overflow hidden
    line-height: 70px;
    margin: 0 auto;
    color: rgb(162, 134, 60);
    font-size: 18px;
    font-weight: 900;
}

.content-introduce {
    font-size: 16px;
    color: rgb(255, 255, 255);
    text-decoration: underline;
}

.envelope-prompt {
    margin-bottom: 10px;
}

.envelope-prompt p {
    font-family: MicrosoftYaHei-Bold;
    font-size: 36px;
    color: #F7DD28;
    letter-spacing: 0;
    text-shadow: 0 2px 4px rgba(130, 130, 130, 0.50);
}

.envelope-prompt span {
    font-family: MicrosoftYaHei;
    font-size: 16px;
    color: #FFFFFF;
    text-shadow: 0 2px 4px rgba(130, 130, 130, 0.50);
}

.list-css {
    position: absolute;
    bottom: 27%;
    width: 81%;
    overflow: auto;
    border-radius: 10px;
    padding: 10px;
    margin-left: 9.5%;
    overflow-y: scroll;
}

.bac-css {
    max-height: 72%;
    min-height: 150px;
    background: rgb(246, 246, 246);
    z-index: 0;
    border-bottom-left-radius: 170px 65px;
    border-bottom-right-radius: 170px 65px;
    -webkit-border-bottom-left-radius: 170px 65px;
    -webkit-border-bottom-right-radius: 170px 65px;
    -o-border-bottom-left-radius: 170px 65px;
    -o-border-bottom-right-radius: 170px 65px;
    -ms-border-bottom-left-radius: 170px 65px;
    -ms-border-bottom-right-radius: 170px 65px;
    -moz-border-bottom-left-radius: 170px 65px;
    -moz-border-bottom-right-radius: 170px 65px;
    -webkit-mask-image: linear-gradient(to bottom, rgb(0, 0, 0), rgb(0, 0, 0));
}

.newbac-css {
    height: 74%;
    background: rgba(0, 0, 0, 0.4);
}

.list-css li {
    height: 86px;
    line-height: 86px;
    font-size: 20px;
    color: rgb(255, 255, 255);
    padding-right: 6%;
    margin-bottom: 6px;
    /*color: rgb(247, 221, 40);*/
}

.price {
    font-family: MicrosoftYaHei-Bold;
    font-size: 20px;
    height: 100%;
    width: 33%;
    text-align: center;
    overflow: hidden;
}

.price .span-css {
    font-size: 16px;
    margin-left: 6px;
}

.toast-body {
    display: block;
    top: 20%;
    padding-bottom: 20px;
    width: 80%;
    left: 10%;
}

.toast-title {
    color: rgb(102, 102, 102);
    border-bottom: 1px solid rgb(221, 221, 221);
    margin: 0px auto;
    display: inline-block;
    padding: 6px 0px;
    height: 50px;
    line-height: 50px;
    font-size: 18px;
}

.toast-msg {
    text-align: left;
    max-height: 290px;
    padding-bottom: 0px;
}

.bacbottom-img {
    position: absolute;
    top: 75%;
    left: 0;
    width: 100%;
    height: 18%;
}

.content-img {
    background-size: 100% 100%;
}

.count {
    font-family: PingFangSC-Medium;
    font-size: 16px;
    color: #A6A6A6;
    width: 100%;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}

.content-fr {
    line-height: 30px;
    padding: 12px 0;
    text-align: right;
    width: 66%;
    overflow: hidden;
}

.dow-title {
    width: 80%;
    background: url(http://atour-wechat.qiniu.yaduo.com/hongbao-Botton@2x.png) no-repeat;
    background-size: contain;
    background-position: center center;
    height: 60px;
    margin: 0 auto;
}
    .look-button {
        width: 80%;
        height: 50px;
        margin: 0 auto;
        color: #D6A984;
        background: #343434
        font-size: 20px
        line-height 50px
        border-radius 25px
        letter-spacing 5px
    }

.envelope-prompt .size-color {
    font-size: 20px;
    color: rgb(228, 193, 147);
}

.content-img {
    background-size: 100% 100%;
}
}
</style>
<template>
    <main v-loading="true">
        <div v-if="iShow">
            <div class="toast-mask" style="display: block;" @click="showToast(false)"></div>
            <div class="toast-body">
                <div class="clearfix">
                    <p class="toast-title">活动介绍</p>
                </div>
                <pre class="toast-msg">{{configData.marketRule}}</pre>
            </div>
        </div>
        <template v-if="configType && !showTreatmentList">
            <div class="wrap">
                <section class="activity-bg" :style="{backgroundImage: 'url(\'' + configData.backgroundImage + '\')'}">
                    <div class="content-topbox">
                        <img :src="configData.logoImage" class="content-logimg">
                    </div>
                    <div class="content-bottbox">
                        <div class="img-wrap">
                            <img :src="configData.envelopeImage">
                        </div>
                        <div class="content-val">
                            <div class="input-wrap">
                                <input @click.stop="getFocus($event)" type="text" placeholder="请正确填写手机号" @blur="fixWindow" v-model="postData.phoneNum">
                            </div>
                            <div class="input-wrap">
                                <input type="text" @click.stop="getFocus($event)" placeholder="请输入验证码" @blur="fixWindow" v-model="postData.verifyCode">
                                <div class="login-get-code msg" @click="getImgCode()">获取验证码</div>
                            </div>
                            <p class="content-button" @click="receiveGifts()"
                               :style="{
                               overflow: 'hidden',
                               height: '17.5vw',
                               backgroundImage: 'url('+ configData.buttonImage +')',
                               backgroundSize: 'contain',
                               backgroundPosition: 'center center',
                               backgroundRepeat: 'no-repeat'}"></p>
                            <p class="content-introduce" @click="showToast(true)">活动规则</p>
                        </div>
                    </div>
                </section>
            </div>
        </template>
        <div class="treatment-list" v-if="showTreatmentList">
            <div class="wrap" v-if="configType">
                <section class="activity-bg" :style="{backgroundImage: 'url(\'' + configData.backgroundImage + '\')'}">
                    <div class="content-topbox">
                        <share :title="configData.subTitle" :desc="configData.shareUrlTitle" :imgUrl="configData.shareUrlImage" :link="link">
                        </share>
                        <img :src="configData.logoImage" class="content-logimg" style="max-height:70px" v-if="configData.sort!=3">
                        <img :src="configData.successSubTitle" class="content-logimg" v-if="configData.sort==3">
                        <div class="envelope-prompt" v-if="configData.sort!=3">
                            <p>{{isLogin ? "已成功领取" : "领取成功"}}</p>
                            <span>优惠券已放入{{upPhoneNum(phone)}}的会员账户</span>
                        </div>
                        <div class="envelope-prompt" v-if="configData.sort==3">
                            <p class="size-color">恭喜您
                                <br/>成为亚朵金卡会员</p>
                            <span>专属百元礼包已放入您的亚朵账户</span>
                        </div>
                    </div>
                    <div class="content-bottbox" :style="configData.marketValue==1?'':(configData.envelopeImage ? ('background: url(' + configData.envelopeImage + ') no-repeat;background-size: 100% 100%;') : '')">
                        <ul class="list-css" tabindex='-1' :class="configData.marketValue==1?'newbac-css':'bac-css'" :style="configData.sort==3?'bottom: 16%;':''">
                            <li class="clearfix content-img" v-for="item in couponList" :style="configData.successSubTitle?('background: url('+configData.successSubTitle+') no-repeat;background-size: 100% 100%;'):''">
                                <div class="fl price clearfix" :style="configData.successTitle?('background: url('+configData.successTitle+') no-repeat;background-size: 100% 100%;'):''">
                                    <p class="">{{item.value}}元</p>
                                </div>
                                <div class="fr content-fr">
                                    <p class="count">{{item.disTypeName}}</p>
                                    <p class="count" style="color: #FB3653;">x{{item.count ? item.count : 1}}</p>
                                </div>
                            </li>
                        </ul>
                        <div class="bacbottom-img">
<!--                            <p class="content-button" v-if="configData.marketValue!=1" @click="goWechat()" :style="configData.buttonImage?('background: url('+configData.buttonImage+') no-repeat;background-size: 100% 100%;'):''">-->
<!--                                立即使用</p>-->
                            <div class="dow-title" @click="useAction" v-if="configData.buttonUrlType === 1"></div>
                            <div class="look-button" @click="lookTicket" v-if="configData.buttonUrlType === 2">去查看</div>
                        </div>
                        <p class="content-introduce" @click="showToast(true)"
                           style="position: absolute;width: 6em;
                           text-align: center;left: 50%;bottom: 0;
                           margin-left: -3em;">活动规则</p>
                    </div>
                </section>
            </div>
        </div>
        <img-code :show="isShow" @showOff="showOff" :phone="postData.phoneNum" :codeType="codeType"></img-code>
    </main>
</template>
<script>
    import { goToIndex, goToTicket } from '@/utils'
    import components from '../components'
    import { reportNew } from '@/assets/js/reportNew.js'
    export default {
        name: 'treatment',
        data() {
            return {
                isShow: false,
                iShow: false,//控制活动介绍
                isLogin: false,
                marketFlag: false,//是否领取过
                configType: false,//是否
                configData: {},
                marketId: "",
                ActivityUserData: {},
                codeKey: null,
                code: null,
                codeType: 1,
                imgCode: "",
                postData: {
                    marketId: this.$route.params.marketId,
                    phoneNum: "",
                    verifyCode: ''
                },

                showTreatmentList: false,
                couponList: []
            }
        },
        created () {
            reportNew.pv({
                pageId: 136
            })
        },
        methods: {
            showToast(type) {
                this.iShow = type;
            },
            showOff() {
                this.isShow = false;
            },
            closeImg() {
                this.isShow = false
            },
            getImgCode() {
                //获取图形验证码
                if (!this.postData.phoneNum) {
                    toast.showToast("请输入手机号！")
                    return false
                } else if (!(/^1[0-9]{10}$/).test(this.postData.phoneNum)) {
                    toast.showToast("手机号格式不正确！")
                    return false
                } else {
                    this.isShow = true
                }
            },
            getMarketConfig() {
                //活动首页基础配置接口
                var data = {
                    marketId: this.marketId
                }
                site._post(JAVA_SERVER + '/atourlife/marketConfig/getMarketConfig', data, this, function (result) {
                    if (result.retcode == 0) {
                        this.$nextTick(function () {
                            this.configData = result.result;
                            this.configType = true;
                            try {
                                if (result.result.isOnlyAtourAPP == 1) {
                                // 判断是否在app内
                                    if (!Prius.isInsideApp) {
                                        location.href = 'https://wechat.yaduo.com/'
                                    }
                                }
                            }catch(e) {}
                        })
                    } else {
                        toast.showToast(result.retmsg)
                    }
                })
            },
            inspectType(data) {
                if (!data || typeof(data) == "undefined" || typeof(data) == "string") {
                    return false;
                }
                return true;
            },
            receiveGifts() {
                reportNew.click({
                    elementId: 218,
                    pageId: 136
                })
                //活动首页领取接口
                var data = {
                    phoneNum: this.postData.phoneNum,
                    marketId: this.marketId,
                    verifyCode: this.postData.verifyCode
                }
                site._post(JAVA_SERVER + '/atourlife/login/receiveRedPacketByVerifyCode', data, this, function (result) {
                    if (result.retcode == 0 || result.retcode == 60008) {
                        localStorage.setItem('getted', true)
                        localStorage.setItem('marketId', this.marketId)
                        localStorage.setItem('mobile', result.result.phoneNum)
                        localStorage.setItem('getTicketTime', Date.now())
                        this.gotoTreatmentList()
                    } else {
                        toast.showToast(result.retmsg);
                    }
                })
            },
            gotoTreatmentList() {
                this.getCoupon()
                // this.$router.push({
                //     path: '/treatmentList/' + this.marketId,
                //     query: {
                //         activitySource: localStorage.getItem('activitySource'),
                //         activeId:localStorage.getItem('activeId')
                //     }
                // });
            },
            listTemp: function(list) {
                let map = {},
                    dest = [];
                for (let i = 0; i < list.length; i++) {
                    let ai = list[i];
                    if (!map[ai.value]) {
                        dest.push({
                            disTypeName: ai.disTypeName,
                            value: ai.value,
                            count: 1
                        });
                        map[ai.value] = ai;
                    } else {
                        for (var j = 0; j < dest.length; j++) {
                            var dj = dest[j];
                            if (dj.value == ai.value) {
                                ++dest[j].count;
                                break;
                            }
                        }
                    }
                }
                return dest
            },
            getCoupon() {
                //获取优惠券列表
                this.phone = localStorage.getItem('mobile')
                var data = { phoneNum: this.phone, marketId: this.marketId }
                if (this.phone) {
                    site._post(JAVA_SERVER + '/atourlife/coupon/getCouponsListByMarketIdNotToken', data, this, function(result) {
                        if (result.retcode == 0) {
                            if (this.configData.marketValue == 1) {
                                this.couponList = result.result
                            } else {
                                this.couponList = this.listTemp(result.result)
                            }
                            this.showTreatmentList = true
                        } else {
                            toast.showToast(result.retmsg);
                        }
                    })
                }
            },
            upPhoneNum(tel) {
                if (tel) {
                    var mtel = tel.substr(0, 3) + '****' + tel.substr(7);
                    return mtel
                }
            },
            goWechat() {
                window.location.href = 'https://wechat.yaduo.com';
            },
            useAction() {
                goToIndex()
            },
            lookTicket () {
                goToTicket()
            },
            fixWindow() {
                window.scrollTo(0,0)
            },
            getFocus(event) {
                event.target.focus()
            }
        },
        components: components,
        mounted() {
            document.getElementsByTagName('input')
            this.marketId = this.$route.params.marketId;
            this.$nextTick(function () {
                this.getMarketConfig()
                if ((localStorage.getItem('getted') == 'true') && (localStorage.getItem('marketId')==this.marketId) ) {
                    this.gotoTreatmentList()
                }
            })
        },
    }
</script>



// WEBPACK FOOTER //
// treatment.vue?4dab83f0